import {
    CHANGE_NEW_PREMIUM_STORE_SETTINGS,
    CHANGE_PREMIUM_SETTINGS_WIZARD_STORE,
    CHANGE_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_AND_CASE_STAGE,
    CHANGE_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_CASE_STAGE_AND_SOLICITOR,
    CHANGE_WIZARD_STEP,
    FAILED_TO_GET_PREMIUM_SETTINGS_WIZARD_MESSAGES,
    FAILED_TO_POST_PREMIUM_SETTING_WIZARD,
    GET_PREMIUM_SETTINGS_WITH_COMBINATION,
    GET_PREMIUM_SETTINGS_WIZARD_STEP_MESSAGES,
    LOGOUT,
    POST_NEW_PREMIUM_SETTING_WIZARD,
    RECEIVE_APPLICATION_PREMIUM_SETTINGS,
    RECEIVE_BAD_REQUEST_APPLICATION_PREMIUM_SETTINGS,
    RECEIVE_BAD_REQUEST_PATCH_APPLICATION_PREMIUM_SETTINGS,
    RECEIVE_BAD_REQUEST_PATCH_POLICY_SETTING,
    RECEIVE_PATCH_RESPONSE_PREMIUM_SETTING,
    RECEIVE_POST_PREMIUM_SETTING_WIZARD,
    RECEIVE_PREMIUM_SETTINGS_BY_ID,
    RECEIVE_PREMIUM_SETTINGS_DAMAGES,
    RECEIVE_PREMIUM_SETTINGS_STAGES,
    RECEIVE_PREMIUM_SETTINGS_WITH_COMBINATION,
    CHANGE_PREMIUM_SETTINGS_WITH_COMBINATION,
    RECEIVE_PREMIUM_SETTINGS_WIZARD_MESSAGES,
    REQUEST_APPLICATION_PREMIUM_SETTINGS,
    REQUEST_GET_SPECIFIC_PREMIUM_SETTING,
    REQUEST_PATCH_APPLICATION_PREMIUM_SETTINGS,
    REQUEST_PATCH_PREMIUM_SETTING,
    RESET_APPLICATION_PREMIUM,
    GET_COVERAGE_TYPES,
    RECEIVE_COVERAGE_TYPES,
    FAILED_GET_COVERAGE_TYPES,
} from "../actions/index";
import _ from 'lodash';
import moment from 'moment';
import {RECEIVE_PATCH_APPLICATION_AFTER_PREMIUM, RECEIVE_PATCH_APPLICATION_PREMIUM_SETTINGS} from "../actions";
import { COUNTRY, UK_COUNTRY } from "../helpers/variables";

const getDamageBandsFromPsDto = (psSubSettings) => {
  try {
      const groupedByStage = _.groupBy(psSubSettings, item => {return item.stageId});
      const dmgBands = Object.values(groupedByStage)[0].map(group => {return group.damages});
      return dmgBands;
  } catch (e) {
      return [];
  }
};

const getSolicitorsFromPsDto = (psSubSettings) => {
    try {
        return psSubSettings[0].premiumSubSettingCommissions.map(item => ({
            id: item.lawsysId,
            name: item.lawsysName
        }))
    } catch (e) {
        return []
    }
};

const getCaseStagesFromPsDto =(psSubSettings) => {
    try {
        return _.uniqBy(psSubSettings, item => item.stageId).map(item => ({
            id: item.stageId,
            name: item.stageName
        }));
    } catch (e) {
        return []
    }
};

const getTableData = (psSubSettings) => {
    try {
        const tData = [];
        _.forEach(psSubSettings, subSetting => {
            let tmp = [];
            let premium = subSetting.premium;
            _.forEach(subSetting.premiumSubSettingCommissions, item => {
                tmp.push({
                    lawsysId: item.lawsysId,
                    lawsysName: item.lawsysName?item.lawsysName:'',
                    commission: !isNaN(Number.parseFloat(item.commission)) ? item.commission.toString() : '',
                    commissionPercentage: !isNaN(Number.parseFloat(item.commissionPercentage)) ? item.commissionPercentage.toString() : '',
                })
            });
            tData.push({
                stageId: subSetting.stageId,
                stageName: subSetting.stageName,
                premium: !isNaN(Number.parseFloat(premium)) ? premium.toString() : '',
                recoverable: !isNaN(Number.parseFloat(subSetting.recoverable)) ? subSetting.recoverable.toString() : '',
                nonRecoverable: !isNaN(Number.parseFloat(subSetting.nonRecoverable)) ? subSetting.nonRecoverable.toString() : '',            
                underwriterRate: !isNaN(Number.parseFloat(subSetting.underwriterRate)) ? subSetting.underwriterRate.toString() : '',
                underwriterRatePercentage: !isNaN(Number.parseFloat(subSetting.underwriterRatePercentage)) ? subSetting.underwriterRatePercentage.toString() : '',
                premiumSubSettingCommissions: tmp,
                damages: subSetting.damages
            })
        });
        return tData;
    } catch (e) {
        return false
    }
};

const defaultState = {
    fetchedApplicationPremium: {},
    currentStep: 1,
    latestStep: 0,
    //step 1 related
    checkedCaseStagesIds: [],
    selectedCaseStages: [],
    //step 2 related
    checkedDamagesIds: [],
    selectedDamages: [],
    startOfDamageBand: '',
    endOfDamageBand: '',
    damageBands: [],
    openDamageBandModal: false,
    //step 3 related
    openSolicitorModal: false,
    selectedSolicitor: '',
    step3WarningMsg:'',
    solicitorsList: [],
    //step 5 related
    limitOfIndemnity: '',
    notes: '',
    comments: '',
	endorsements: '',
    validFrom: '',
    validationMessageStep5:'',
    //step 4 related
    tableData: [],
    recoverableRatePercentage: '',
    validationMessage: '',
    //step 6 related
    posting: false,
    successMsg: '',
    badResponseMsg: '',
    validUntil: '',
    //premium setting already exists related
    solicitorListLength: 0,
    caseTypeName: '',
    caseTypeId: '',
    subCaseTypeName: '',
    subCaseTypeId: '',
    workSourceName: '',
    solicitorGroupName: '',
    solicitorGroupId: '',
    //step messages
    fetchingStepMessages: false,
    stepMessages: [],
    //general
    isEditMode: false,
    editId: '',
    //premium settings type
    isPercentagePremium: false,
    //patching
    patching: false,
    fetchingExistingPremium: false,
    failedToFetchMessage: '',
    coveragesOptions:[],
    deductiblesOptions:[],
    endorsementsOptions:[],
    selectedCoverageType:'',
    selectedDeductible:'',
    selectedEndorsement:'',
    displayedCoverageType:'',
    displayedDeductible:'',
    displayedEndorsement:'',
    fetchingCoverageTypes:false,
};

export default (state = defaultState, action) => {
    let newTableData; 
    switch (action.type) {
        case GET_COVERAGE_TYPES:
            return {
                ...state,
                fetchingCoverageTypes: true
            };
            case RECEIVE_COVERAGE_TYPES:
            return {
                ...state,
                coveragesOptions:action.payload.coverageOptions,
                deductiblesOptions:action.payload.deductibleOptions,
                endorsementsOptions:action.payload.endorsementOptions,
                fetchingCoverageTypes: false
            };
            case FAILED_GET_COVERAGE_TYPES:
            return {
                ...state,
                currentStep: defaultState.currentStep,
                fetchingCoverageTypes: false
            };
        case RECEIVE_PATCH_APPLICATION_AFTER_PREMIUM:
            return {
                ...state,
                currentStep: defaultState.currentStep,
                makeApplicationLive: false
            };
        case RESET_APPLICATION_PREMIUM:
            if(!state.fetchedApplicationPremium.applicationPremiumSubSettingsDtos){
                return {
                    ...state,
                }
            }
            let solicitorListLength = 0;
            solicitorListLength = state.fetchedApplicationPremium.applicationPremiumSubSettingsDtos[0].premiumSubSettingCommissions.length
            let tData = getTableData(state.fetchedApplicationPremium.applicationPremiumSubSettingsDtos);
            const dmgBands = getDamageBandsFromPsDto(state.fetchedApplicationPremium.applicationPremiumSubSettingsDtos);
            const solList = getSolicitorsFromPsDto(state.fetchedApplicationPremium.applicationPremiumSubSettingsDtos);
            const checkedStages = getCaseStagesFromPsDto(state.fetchedApplicationPremium.applicationPremiumSubSettingsDtos);
            return {
                ...state,
                badResponseMsg: defaultState.badResponseMsg,
                currentStep: defaultState.currentStep,
                selectedCaseStages: checkedStages,
                solicitorsList: solList,
                damageBands: dmgBands,
                isEditMode: true,
                comments:state.fetchedApplicationPremium.comments,
                endorsements:state.fetchedApplicationPremium.endorsements,
                notes:state.fetchedApplicationPremium.notes,
                validFrom: state.fetchedApplicationPremium.validFrom,
                validUntil:state.fetchedApplicationPremium.validUntil ? state.fetchedApplicationPremium.validUntil : '',
                limitOfIndemnity: state.fetchedApplicationPremium.limitOfIndemnity.toString(),
                tableData: _.orderBy(tData, ['stageId']),
                solicitorListLength: solicitorListLength,
                editId: state.fetchedApplicationPremium.id,
                fetchingExistingPremium: false,
                caseTypeName: state.fetchedApplicationPremium.caseTypeName?state.fetchedApplicationPremium.caseTypeName:'',
                caseTypeId: state.fetchedApplicationPremium.caseTypeId?state.fetchedApplicationPremium.caseTypeId:'',
                subCaseTypeName: state.fetchedApplicationPremium.subCaseTypeName?state.fetchedApplicationPremium.subCaseTypeName:'',
                subCaseTypeId: state.fetchedApplicationPremium.subCaseTypeId?state.fetchedApplicationPremium.subCaseTypeId:'',
                workSourceName: state.fetchedApplicationPremium.workSourceName?state.fetchedApplicationPremium.workSourceName:'',
                solicitorGroupName: state.fetchedApplicationPremium.solicitorGroupName?state.fetchedApplicationPremium.solicitorGroupName:'',
                solicitorGroupId: state.fetchedApplicationPremium.solicitorGroupId?state.fetchedApplicationPremium.solicitorGroupId:'',
            };
        case REQUEST_PATCH_APPLICATION_PREMIUM_SETTINGS:
            return {
                ...state,
                patching: true,
                makeApplicationLive: action.payload.makeApplicationLive,
                badResponseMsg: defaultState.badResponseMsg
            };
        case RECEIVE_PATCH_APPLICATION_PREMIUM_SETTINGS:
            let lawsysLength = null;
            if(action.payload.applicationPremiumSubSettingsDtos.length > 0 )
            {
                try {
                    lawsysLength = action.payload.applicationPremiumSubSettingsDtos[0].premiumSubSettingCommissions.length;
                } catch (e) {
                    lawsysLength = state.solicitorListLength;
                }
                return {
                    ...state,
                    fetchedApplicationPremium: action.payload,
                    patching: false,
                    solicitorListLength: lawsysLength,
                    currentStep: state.makeApplicationLive?state.currentStep:defaultState.currentStep
                };
            }
           return {
            ...state,
            patching: false,
           }
        case RECEIVE_BAD_REQUEST_PATCH_APPLICATION_PREMIUM_SETTINGS:
            let patchApplicationPremiumSettingsFailResponse = '';
            try {
                patchApplicationPremiumSettingsFailResponse = action.payload.response.body.message;
            } catch (e) {
                patchApplicationPremiumSettingsFailResponse = 'Failed to update application premium setting.'
            }
            return{
                ...state,
                patching: false,
                badResponseMsg: patchApplicationPremiumSettingsFailResponse
            };
        case REQUEST_APPLICATION_PREMIUM_SETTINGS:
            return {
                ...state,
                fetchingExistingPremium: true,
                badResponseMsg: defaultState.badResponseMsg,
                failedToFetchMessage: defaultState.failedToFetchMessage,
            };
        case RECEIVE_BAD_REQUEST_APPLICATION_PREMIUM_SETTINGS:
            let fetchApplicationsPremiumSettingsErrorMessage = '';
            try {
                fetchApplicationsPremiumSettingsErrorMessage = action.payload.response.body.message;
            } catch (e) {
                fetchApplicationsPremiumSettingsErrorMessage = 'Failed to fetch application premium settings.'
            }
            return{
                ...state,
                fetchingExistingPremium: false,
                failedToFetchMessage: fetchApplicationsPremiumSettingsErrorMessage
            };
        case RECEIVE_APPLICATION_PREMIUM_SETTINGS:
            if(action.payload !== null){
                if(action.payload.applicationPremiumSubSettingsDtos?.length === 0 &&
                    action.payload.applicationStagedPremiumSubSettingDtos?.length === 0 ){
                    return {
                        ...state,
                        fetchingExistingPremium: false,
                        failedToFetchMessage: 'Failed to load application premium settings',
                       
                    }
                }
                if(action.payload.applicationPremiumSubSettingsDtos?.length !== 0)
                {
                let solicitorListLength = 0;
                solicitorListLength = action.payload.applicationPremiumSubSettingsDtos[0].premiumSubSettingCommissions.length
                let tData = getTableData(action.payload.applicationPremiumSubSettingsDtos);
                const dmgBands = getDamageBandsFromPsDto(action.payload.applicationPremiumSubSettingsDtos);
                const solList = getSolicitorsFromPsDto(action.payload.applicationPremiumSubSettingsDtos);
                const checkedStages = getCaseStagesFromPsDto(action.payload.applicationPremiumSubSettingsDtos);
                return {
                    ...state,
                    fetchedApplicationPremium: action.payload,
                    selectedCaseStages: checkedStages,
                    solicitorsList: solList,
                    damageBands: dmgBands,
                    isEditMode: true,
                    comments:action.payload.comments,
                    endorsements:action.payload.endorsements,
                    notes:action.payload.notes,
                    validFrom: action.payload.validFrom ? new Date(action.payload.validFrom) :  new Date(),
                    validUntil: action.payload.validUntil ? new Date(action.payload.validUntil) : '',
                    limitOfIndemnity: action.payload.limitOfIndemnity.toString(),
                    recoverableRatePercentage: action.payload.recoverableRatePercentage ? action.payload.recoverableRatePercentage.toString() : '',
                    isPercentagePremium: action.payload.isPercentagePremium,
                    tableData: _.orderBy(tData, ['stageId']),
                    solicitorListLength: solicitorListLength,
                    editId: action.payload.id,
                    fetchingExistingPremium: false,
                    caseTypeName: action.payload.caseTypeName?action.payload.caseTypeName:'',
                    caseTypeId: action.payload.caseTypeId?action.payload.caseTypeId:'',
                    subCaseTypeName: action.payload.subCaseTypeName?action.payload.subCaseTypeName:'',
                    subCaseTypeId: action.payload.subCaseTypeId?action.payload.subCaseTypeId:'',
                    workSourceName: action.payload.workSourceName?action.payload.workSourceName:'',
                    solicitorGroupName: action.payload.solicitorGroupName?action.payload.solicitorGroupName:'',
                    solicitorGroupId: action.payload.solicitorGroupId?action.payload.solicitorGroupId:'',
                    selectedCoverageType:action.payload.coverageOptionId!= null ?action.payload.coverageOptionId : '',
                    selectedDeductible: action.payload.deductibleOptionId != null ? action.payload.deductibleOptionId : '',
                    selectedEndorsement: action.payload.endorsementOptionId != null ? action.payload.endorsementOptionId : '',
                    displayedCoverageType: action.payload.coverageOptionName != null ? action.payload.coverageOptionName : '',
                    displayedDeductible: action.payload.deductibleOptionName != null ? action.payload.deductibleOptionName : '',
                    displayedEndorsement: action.payload.endorsementOptionName != null ? action.payload.endorsementOptionName : '',
                };
                 }


            }
            if(action.payload?.id != null){
                return {
                    ...state,
                    editId: action.payload.id,
                    fetchingExistingPremium: false
                };
            }
            return {
                ...state,
                fetchingExistingPremium: false
            };
        case REQUEST_GET_SPECIFIC_PREMIUM_SETTING:
            return {
                ...state,
                fetchingExistingPremium: true
            };
        case REQUEST_PATCH_PREMIUM_SETTING:
            return {
                ...state,
                patching:true
            };
        case RECEIVE_PATCH_RESPONSE_PREMIUM_SETTING:
            return {
                ...state,
                patching: false,
                successMsg: 'Premium setting was updated successfully.'
            };
        case RECEIVE_BAD_REQUEST_PATCH_POLICY_SETTING:
            if(action.payload.status === 400){
                return {
                    ...state,
                    patching: false,
                    badResponseMsg: action.payload.response.body.message
                };
            }
            return {
                ...state,
                patching: false,
                badResponseMsg: 'Failed to update premium setting.'
            };
        case RECEIVE_PREMIUM_SETTINGS_BY_ID:
            const premiumSettings = action.payload.premiumSettings;
            if(premiumSettings !== null){
                let subSetting = action.payload.premiumSettings.percentagePremiumSubSettings && action.payload.premiumSettings.percentagePremiumSubSettings.length > 0 ? action.payload.premiumSettings.percentagePremiumSubSettings : action.payload.premiumSettings.premiumSubSettings;
                let solicitorListLength = 0;
                solicitorListLength = subSetting[0].premiumSubSettingCommissions.length
                let tData = getTableData(subSetting);
                const dmgBands = getDamageBandsFromPsDto(subSetting);
                const solList = getSolicitorsFromPsDto(subSetting);
                const checkedStages = getCaseStagesFromPsDto(subSetting);
                return {
                    ...state,
                    selectedCaseStages: checkedStages,
                    solicitorsList: solList,
                    damageBands: dmgBands,
                    isEditMode: !!action.payload.isEditMode,
                    comments:premiumSettings.comments,
                    endorsements:premiumSettings.endorsements,
                    notes:premiumSettings.notes,
                    validFrom: new Date(premiumSettings.validFrom),
                    validUntil: premiumSettings.validUntil ? new Date(premiumSettings.validUntil) : '',
                    limitOfIndemnity: premiumSettings.limitOfIndemnity.toString(),
                    recoverableRatePercentage: premiumSettings.recoverableRatePercentage ? premiumSettings.recoverableRatePercentage.toString() : '',
                    tableData: _.orderBy(tData, ['stageId']),
                    solicitorListLength: solicitorListLength,
                    editId: premiumSettings.id,
                    fetchingExistingPremium: false,
                    caseTypeName: premiumSettings.caseTypeName?premiumSettings.caseTypeName:'',
                    caseTypeId: premiumSettings.caseTypeId?premiumSettings.caseTypeId:'',
                    subCaseTypeName: premiumSettings.subCaseTypeName?premiumSettings.subCaseTypeName:'',
                    subCaseTypeId: premiumSettings.subCaseTypeId?premiumSettings.subCaseTypeId:'',
                    workSourceName: premiumSettings.workSourceName?premiumSettings.workSourceName:'',
                    solicitorGroupName: premiumSettings.solicitorGroupName?premiumSettings.solicitorGroupName:'',
                    solicitorGroupId: premiumSettings.solicitorGroupId ? premiumSettings.solicitorGroupId : '',
                    workSourceId: premiumSettings.workSourceId ? premiumSettings.workSourceId : '',
                    selectedCoverageType:premiumSettings.coverageOptionId!= null ?premiumSettings.coverageOptionId : '',
                    selectedDeductible:premiumSettings.deductibleOptionId != null ?premiumSettings.deductibleOptionId : '',
                    selectedEndorsement:premiumSettings.endorsementOptionId != null ?premiumSettings.endorsementOptionId : '',
                    displayedCoverageType:premiumSettings.coverageOptionName!= null ?premiumSettings.coverageOptionName : '',
                    displayedDeductible:premiumSettings.deductibleOptionName != null ?premiumSettings.deductibleOptionName : '',
                    displayedEndorsement:premiumSettings.endorsementOptionName != null ?premiumSettings.endorsementOptionName : '',
                };
            }
            return {
                ...state,
                fetchingExistingPremium: false
            };
        case GET_PREMIUM_SETTINGS_WIZARD_STEP_MESSAGES:
            return {
                ...state,
                fetchingStepMessages: true
            };
        case RECEIVE_PREMIUM_SETTINGS_WIZARD_MESSAGES:
            return {
                ...state,
                fetchingStepMessages: false,
                stepMessages: action.payload
            };
        case FAILED_TO_GET_PREMIUM_SETTINGS_WIZARD_MESSAGES:
            return {
                ...state,
                fetchingStepMessages: false,
            };
        case CHANGE_NEW_PREMIUM_STORE_SETTINGS:
            return {
                ...defaultState
            };
        case GET_PREMIUM_SETTINGS_WITH_COMBINATION:
            return {
                ...defaultState
            };
        case RECEIVE_PREMIUM_SETTINGS_WITH_COMBINATION:
        case CHANGE_PREMIUM_SETTINGS_WITH_COMBINATION:
            if(!_.isEmpty(action.payload)){
                let subSetting = action.payload.percentagePremiumSubSettings && action.payload.percentagePremiumSubSettings.length > 0 ? 
                    action.payload.percentagePremiumSubSettings : action.payload.premiumSubSettings;
                let solicitorListLength = 0;
                solicitorListLength = subSetting[0].premiumSubSettingCommissions.length ;
                let tData = getTableData(subSetting);
                const dmgBands = getDamageBandsFromPsDto(subSetting);
                const solList = getSolicitorsFromPsDto(subSetting);
                const checkedStages = getCaseStagesFromPsDto(subSetting);
                return {
                    ...state,
                    selectedCaseStages: checkedStages,
                    solicitorsList: solList,
                    damageBands: dmgBands,
                    currentStep: 6,
                    comments:action.payload.comments,
					endorsements:action.payload.endorsements,
                    displayedCoverageType:action.payload.coverageOptionName != null ?action.payload.coverageOptionName : '',
                    displayedDeductible:action.payload.deductibleOptionName != null ?action.payload.deductibleOptionName : '',
                    displayedEndorsement:action.payload.endorsementOptionName != null ?action.payload.endorsementOptionName : '',
                    notes:action.payload.notes,
                    validFrom: action.payload.validFrom,
                    validUntil: action.payload.validUntil,
                    limitOfIndemnity:action.payload.limitOfIndemnity.toString(),
                    tableData: _.orderBy(tData, ['stageId']),
                    recoverableRatePercentage: action.payload.recoverableRatePercentage ? action.payload.recoverableRatePercentage.toString() : '',
                    solicitorListLength: solicitorListLength
                };
            }
            return {
                ...state
            };
        case POST_NEW_PREMIUM_SETTING_WIZARD:
            return {
                ...state,
                posting: true,
                successMsg: '',
                badResponseMsg: ''
            };
        case RECEIVE_POST_PREMIUM_SETTING_WIZARD:
            return {
                ...state,
                posting: false,
                successMsg: 'Premium setting was created successfully.'
            };
        case FAILED_TO_POST_PREMIUM_SETTING_WIZARD:
            if(action.payload.status === 400){
            return {
                ...state,
                posting: false,
                badResponseMsg: action.payload.response.body.message
            };
        }
            return {
                ...state,
                posting: false,
                badResponseMsg: 'Failed to create premium setting.'
            };
        case CHANGE_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_AND_CASE_STAGE:
            newTableData = [...state.tableData];
            newTableData[action.payload.tableIndex][action.payload.field] = action.payload.value;
            return {
                ...state,
                tableData: newTableData,
                validationMessage: ''
            };
        case CHANGE_PREMIUM_SETTINGS_WIZARD_STORE_BY_DAMAGE_CASE_STAGE_AND_SOLICITOR:
            newTableData = [...state.tableData];
            newTableData[action.payload.tableIndex].premiumSubSettingCommissions[action.payload.solicitorIndex][action.payload.field] = action.payload.value;
            return {
                ...state,
                tableData: newTableData,
                validationMessage: ''
            };
        case RECEIVE_PREMIUM_SETTINGS_STAGES:
            return {
                ...state,
                selectedCaseStages: state.selectedCaseStages.length === 0 && COUNTRY == UK_COUNTRY? [_.find(action.payload, (item) => {
                    return item.name === 'Pre-Issue'
                })]:state.selectedCaseStages,
            };
        case CHANGE_PREMIUM_SETTINGS_WIZARD_STORE:
            if(action.payload.key ==='selectedCoverageType')
            {
                var coverageToDisplay = state.coveragesOptions.filter(o => o.id ===action.payload.value);
                if(coverageToDisplay.length > 0 )
                {
                return{
                    ...state,
                [action.payload.key]: action.payload.value,
                displayedCoverageType: coverageToDisplay[0].name,
            }
        }
        };
        if(action.payload.key ==='selectedDeductible')
            {
                var deductibleToDisplay = state.deductiblesOptions.filter(o => o.id ===action.payload.value);
                if(deductibleToDisplay.length>0)
                {
                return{
                    ...state,
                [action.payload.key]: action.payload.value,
                displayedDeductible:  deductibleToDisplay[0].name
            }
        }
        };
        if(action.payload.key ==='selectedEndorsement')
            {
                var endorsementToDisplay = state.endorsementsOptions.filter(o => o.id ===action.payload.value);
                if(endorsementToDisplay.length > 0)
                {
                return{
                    ...state,
                [action.payload.key]: action.payload.value,
                displayedEndorsement: endorsementToDisplay[0].name,
            }}
        };
            return {
                ...state,
                [action.payload.key]: action.payload.value,
                latestStep: action.payload.key === 'currentStep'? state.currentStep : state.latestStep,
                successMsg: '',
                badResponseMsg: '',
                validationMessageStep5: action.payload.key === 'validationMessageStep5'? action.payload.value:''
            };
        case CHANGE_WIZARD_STEP:
            if (action.payload === 'increase')
                return {
                    ...state,
                    currentStep: state.currentStep + 1,
                    latestStep: state.currentStep + 1 > state.latestStep ? 0 : state.latestStep,
                    successMsg: '',
                    badResponseMsg: '',
                    validationMessageStep5:''
            };
            if (action.payload === 'decrease')
                return {
                    ...state,
                    currentStep: state.currentStep - 1,
                    latestStep: state.latestStep === 0 ? state.currentStep: state.latestStep,
                    successMsg: '',
                    badResponseMsg: '',
                    validationMessageStep5: ''
                };
            return {
                ...state
            };
        case LOGOUT:
            return {
                ...defaultState
            };
        case '@@router/LOCATION_CHANGE':
            return {
                ...defaultState
            };
        default :
            return state
    }
}
